import { render } from "./homepage.vue?vue&type=template&id=1d2bcc8f"
import script from "./homepage.vue?vue&type=script&lang=js"
export * from "./homepage.vue?vue&type=script&lang=js"

import "./homepage.vue?vue&type=style&index=0&id=1d2bcc8f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__